import { render, staticRenderFns } from "./SupplierCheckboxes.vue?vue&type=template&id=02b8b1c0&scoped=true"
import script from "./SupplierCheckboxes.vue?vue&type=script&lang=js"
export * from "./SupplierCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./SupplierCheckboxes.vue?vue&type=style&index=0&id=02b8b1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8b1c0",
  null
  
)

export default component.exports